"use client";

import { useEffect } from "react";

import { usePageInfo } from "@/hooks/usePageInfo";

const TITLE_SUFFIX = " - GoGive";

export function DocumentTitle({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute("content", description);
      }
    }
  }, [title, description]);

  return null;
}

/** Sets the tab title from the current nav route, e.g. `Donors - GoGive`. */
export function RouteDocumentTitle({ fallback = "Dashboard" }: { fallback?: string }) {
  const { name } = usePageInfo();
  const pageName = name ?? fallback;

  return <DocumentTitle title={`${pageName}${TITLE_SUFFIX}`} />;
}
